import editableField from "./editableField.component";

const editableFieldModule = angular
  .module("app.components.editableField", [])
  .component("editableField", editableField);

export default editableFieldModule;



// WEBPACK FOOTER //
// ./src/components/editableField/editableField.module.js